module.exports = __webpack_public_path__ + "img/cd2a26e.jpg";